import { useState } from "react";
import { CardOpportunity } from "../../common/components/card/opportunity";
import { textChooser } from "../../common/util/textChooser";
import { Field } from "../../common/components/controls/field";
import { useOpportunities } from "../../common/hooks/Opportunities";
import { LoadingPage } from "../../common/components/loading/loadingPage";
import { ErrorPage } from "../../common/components/template_page/errorPage";
import { IOpportunity } from "../../common/constants/app.dto";
import { useUser } from "../../common/hooks/User";
import "./home.style.scss";
import { MessageEmpty } from "./messageEmpty";

export const Home = () => {
  const [filters, setFilters] = useState({ search: "", mode: "" });
  const { getDataByAttributeName } = useUser()
  const id = getDataByAttributeName('id');

  const { isLoading, isSuccess, isError, data: opportunities } = useOpportunities({ userId: id });

  const sortOpportunityByDate = (a: IOpportunity, b: IOpportunity) => {
    if (a.createdAt > b.createdAt)
      return -1;
    if (a.createdAt < b.createdAt)
      return 1;
    return 0;
  }

  const filteredData = opportunities.sort(sortOpportunityByDate).filter((opportunity) =>
    opportunity.name.toLowerCase().includes(
      filters.search.toLowerCase()
    ) &&
    opportunity.opportunitySubscriptions.some(_ => _.customerId === id)
  )

  const handleOnKeyDownFilter = ({ target: { value } }: any) => {
    setFilters({ ...filters, search: value });
  }

  return (
    <div className="page -home">
      <h1 className="page-title">{textChooser("txt67")}</h1>

      <section className="home-contollers">
        <div className="row isCentered">
          <div className="col-xs-12 col-md-4">
            <Field
              type="search"
              hasError={false}
              hasIcon={false}
              placeholder={textChooser("txt154")}
              label={textChooser("txt59")}
              onChange={handleOnKeyDownFilter}
              maxLength={60}
              minLength={0}
            />
          </div>
        </div>
      </section>

      <section className="home-section">
        {(() => {
          if (isLoading)
            return <LoadingPage />;

          if (!filteredData.length)  
            return <MessageEmpty/>

          if (isSuccess)
            return filteredData.map((ops) =>
              <CardOpportunity {...ops} key={ops.id} />)

          if (isError)
            return <ErrorPage />;
        })()}
      </section>
    </div>
  )
}